import Button from '@/components/Button';
import user from '@/stores/user';
import { trackEvent } from '@/utils/gtag';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const StyledButton = styled(Button)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important;
    background-color: black !important;
    color: white !important;
    font-size: 14px !important;
`;

interface Props {
    className?: string;
}

function ConnectWallet({ className = '' }: Props) {
    const { openConnectModal } = useConnectModal();
    const location = useLocation();

    const clickConnectWallet = () => {
        trackEvent('click_connect_wallet_button', {
            page_path: location.pathname,
        });
        openConnectModal?.();
    };

    if (user.connected) return null;

    return (
        <>
            <StyledButton onClick={clickConnectWallet} className={className}>
                Connect Wallet
            </StyledButton>
        </>
    );
}

export default observer(ConnectWallet);
